import get from 'lodash/get';
import i18n from '@/i18n/index';
import uniqBy from 'lodash/uniqBy';
import genererGuid from '@/services/general/genererGuid';
import { dataURItoFile } from '@/services/general/general';
import { parseGoogleAddress } from '@/services/general/genererAdresse';

function formatData(data) {
  return {
    data,
    id: data.id || data.num,
    libelle: data.nomCommercial || data.libelle,
    children: [],
    selected: false,
    openSecteur: false,
  };
}

function compare(a, b) {
  if (a.libelle.toLowerCase() < b.libelle.toLowerCase()) return -1;
  if (a.libelle.toLowerCase() > b.libelle.toLowerCase()) return 1;
  return 0;
}

function getMarqueConcurrent(tiersMarque, marques) {
  if (!tiersMarque) return '';
  const marque = marques.find(m => m.id === tiersMarque.marqueId);
  return marque ? marque.libelle : '';
}

export function getLogoFileFromDataURI(urlLogo) {
  if (!urlLogo) return null;
  if (urlLogo.includes("data:image/")) return dataURItoFile(urlLogo);
  return null;
}

export function placeToConcurrent(place, pointDeVente) {
  const formattedAdresse = parseGoogleAddress(place.formatted_address);
  return {
    position: {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    },
    animation: google.maps.Animation.DROP,
    urlLogo: place.photos ? place.photos[0].getUrl() : '',
    name: place.name,
    adresse: place.formatted_address,
    icon: place.icon,
    types: place.types,
    ville:  formattedAdresse ? formattedAdresse.ville : '',
    selected: false,
    placeId: place.place_id,
    enseigne: pointDeVente.tiersParent.nomCommercial,
    secteurActivite: '',
    tiersMarques: pointDeVente.tiersMarques,
    enseigneId: pointDeVente.tiersParentId,
    secteurActiviteId: pointDeVente.secteurActiviteId,
    adressePostale: null,
  };
}

export default function formatageConcurrents(pdvs, secteursActivites, secteurActiviteId, marques) {
  const data = [];
  const pdvsFormat = pdvs.map(p => {
    return {
      id: p.num,
      urlLogo: p.urlLogo,
      libelle: p.nomCommercial,
      coordonnees: { lat: p.latitude, lng: p.longitude },
      marque: getMarqueConcurrent(get(p, 'tiersParent.tiersMarques[0]', p.tiersMarques[0]), marques),
      secteurActiviteId: get(p, 'tiersParent.secteurActiviteId', null) || p.secteurActiviteId,
    };
  });

  const pdvsWithoutSecteur = pdvsFormat.filter(p => !p.secteurActiviteId);
  const pdvsWithSecteur = pdvsFormat.filter(p => p.secteurActiviteId);

  secteursActivites.forEach(secteur => {
    const pdvsSecteur = pdvsWithSecteur.filter(p => p.secteurActiviteId === secteur.id);

    const marques = uniqBy(pdvsSecteur.filter(p => !!p.marque)
      .map(p => ({ libelle: p.marque.trim(), id: genererGuid() })), 'libelle')
      .map(formatData).sort(compare);
    marques.forEach(marque => {
      marque.children = pdvsSecteur
        .filter(p => !!p.marque && p.marque.trim() === marque.libelle)
        .map(formatData)
        .sort(compare);
    });

    const pdvsWithoutMarque = pdvsSecteur.filter(p => !p.marque)
      .map(formatData)
      .map(p => ({ ...p, isPdv: true }))
      .sort(compare);

    data.push({
      ...formatData(secteur),
      children: [...marques, ...pdvsWithoutMarque]
    });
  });

  if (pdvsWithoutSecteur.length) {
    const sansSecteur = {
      data: { id: 'sans-secteur', libelle: i18n.t('concurrent.sansSecteurActivite') },
      id: 'sans-secteur',
      libelle: i18n.t('concurrent.sansSecteurActivite'),
      selected: false,
      openSecteur: false,
      children: pdvsWithoutSecteur.map(formatData).map(p => ({ ...p, isPdv: true })).sort(compare),
    };
    data.push(sansSecteur);
  }

  const dataSort = data.filter(el => el.children.length).sort(compare);
  if (secteurActiviteId) {
    const index = dataSort.findIndex(el => el.id === secteurActiviteId);
    if (index !== -1) {
      const currentSecteur = dataSort[index];
      currentSecteur.selected = true;
      currentSecteur.openSecteur = true;
      currentSecteur.children.forEach(el => {
        el.selected = true;
        el.children.forEach(c => {
          c.selected = true;
        })
      })
      dataSort.splice(index, 1);
      dataSort.unshift(currentSecteur);
    }
  }
  return dataSort;
}
